import Flex from "components/grid/Flex";
import { useTranslation } from "react-i18next";
import HistoryContainerAndTitle from "./HistoryContainerAndTitle";
import { isAnyPresent, makeHistory } from "../../HistoryUtils";
import ConditionalLabel from "./ConditionalLabel";
import { Typography } from "@material-ui/core";
import ConditionalLabelAndValue from "./ConditionalLabelAndValue";

const ClinicalSymptomsHistory = ({ anamnesisHistory }) => {
    const { t } = useTranslation();
    const history = makeHistory(anamnesisHistory);
    const isVisible = isAnyPresent(anamnesisHistory, [
        "hasNYHA",
        "nyhaValue",
        "periphereOdeme",
        "neckVeinCongestion",
        "ruhedyspnose",
        "rattlingNoises",
        "hasCCS",
        "ccsValue",
    ]);
    return (
        <HistoryContainerAndTitle title={t(`anamnesis.clinical.title`)} isVisible={isVisible}>
            <Flex item grow={0} container column style={{ margin: "5px 0px" }}>
                    <ConditionalLabelAndValue
                        {...{
                            switchValue: history.getLatestValueOf("hasNYHA"),
                            value: history.getLatestValueOf("nyhaValue") ||
                            history.getLatestValueOf("periphereOdeme") ||
                            history.getLatestValueOf("neckVeinCongestion") ||
                            history.getLatestValueOf("ruhedyspnose") ||
                            history.getLatestValueOf("rattlingNoises")
                                ? <Flex item container grow={0} gap={10} alignItems={"center"}>
                                    {history.getLatestValueOf("nyhaValue") && (
                                        <Typography>
                                            {t(`anamnesis.clinical.nyhaValue.${history.getLatestValueOf("nyhaValue")}`)}
                                        </Typography>
                                    )}
                                    {["periphereOdeme", "neckVeinCongestion", "ruhedyspnose", "rattlingNoises"].map((value) =>
                                        history.getLatestValueOf(value) ? (
                                            <Typography style={{fontWeight: 'bold'}}>{ " " + t(`anamnesis.clinical.${value + "Button"}`)} {history.getLatestValueOf(value)}</Typography>
                                        ) : (
                                            <></>
                                        ),
                                    )}
                                </Flex>
                                : "",
                            label: t("anamnesis.clinical.nyhaValueLabel"),
                        }}
                    />
                <ConditionalLabelAndValue
                    {...{
                        switchValue: history.getLatestValueOf("hasCCS"),
                        value: history.getLatestValueOf("ccsValue")
                            ? <Flex item container grow={0} gap={10} alignItems={"center"}>
                                {history.getLatestValueOf("ccsValue") && (
                                    <Typography>{t(`anamnesis.clinical.CCS.${history.getLatestValueOf("ccsValue")}`)}</Typography>
                                )}
                            </Flex>
                            : "",
                        label: t("anamnesis.clinical.CCSValueLabelInQuery"),
                    }}
                />
            </Flex>
        </HistoryContainerAndTitle>
    );
};

export default ClinicalSymptomsHistory;
